export const SET_USER = 'SET_USER';
export const LOGOUT = "LOGOUT";
export const UPDATED_CONTENT = 'UPDATED_CONTENT';
export const CLEAR_UPDATED_CONTENT = 'CLEAR_UPDATED_CONTENT';